.fp-toast(:class='`-${toast.type}`' data-test='toast' @mouseenter='enter' @mouseleave='leave')
  .fp-toast--message
    i.fp-icon.-s18(:class='[`-color-${toast.type}`, icon]')
    span.fp-text {{ toast.message }}
  .fp-toast--action(data-test='toast.close' @click='close')
    i.fp-icon.fp-glyph-close.-s16
  .fp-toast--progress(:style='`width: ${progressBarWidth}%;`')
